function createMainLegend(chart){
	chart.selectAll('.legend').remove();
	chart.selectAll(selectForLegend)
		.attr('data-legend', chartLegendFunction);
	chart.selectAll('svg').style('overflow', 'visible');

	var legend = chart.selectAll('svg').append('g')
		.attr("class","legend")
		.attr("transform", "matrix(1 0 0 1 0 -20)")
		.style("font-size","12px")
		.call(d3.legend);

	var legendWidth = parseInt($('#main-chart svg .legend-box').attr('width')) - 5.5;
	var svgWidth = $('#main-chart svg').width();
	legend
		.attr("transform", "matrix(1 0 0 1 "+((svgWidth - legendWidth) + 1)+" -20)");
}